import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Cookies from 'js-cookie';
import { AuthActions } from '../actions/auth';
import { getActionIds } from '../helpers/redux';
import { subscriptionClient } from '../apollo/index';

const authActions = getActionIds(AuthActions);

export function redirectToHome(dispatch) {
  dispatch(AuthActions.getMe()).then(a => {
    dispatch(push('/projects'));
    subscriptionClient.connectionParams.authToken = localStorage.accessToken;
    subscriptionClient.close(false);
  });
}

export function* redirectToLogin() {
  Cookies.remove('accessToken');
  localStorage.clear();
  sessionStorage.clear();
  yield put({ type: 'CLEAR_ACCESS_TOKEN' });
  yield put(push('/login'));
}

export default function* root(dispatch) {
  yield [
    takeEvery(
      authActions.authenticate.success,
      redirectToHome.bind(this, dispatch),
    ),
    takeEvery(authActions.logout.success, redirectToLogin),
    takeEvery(authActions.getMe.failure, redirectToLogin),
    takeEvery('401', redirectToLogin),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/index.js